<template>
  <div style="position: fixed;bottom: 0; width: 100%">
    <temp-render
      :ref="'temp-' + code"
      :code="code"
      :attr="tempObj"
      v-if="isRender"
      @action="handleOpenLocalPath"
    />
  </div>
</template>
<script>
export default {
  name: "npmFooter",
  data(){
    return{
      code: 'TableBar',
      tempObj: {
        temporaryPageEnd:{},
        isH5:true
      },
      isRender:false,
    }
  },
  created() {
    this.initTemp();
  },
  methods:{
    async initTemp () {
      let tempData = JSON.parse(localStorage.getItem('setTempConfigs'));
      if (tempData.pageEnd == null) return;
      tempData.pageEnd.token = localStorage.getItem('token');
      this.pageEndSetting = tempData.pageEndSetting;
      this.tempObj.temporaryPageEnd = tempData.pageEnd;
      this.tempObj.temporaryPageEnd.token = localStorage.getItem('token');
      this.tempObj.temporaryPageEnd.selectId = localStorage.getItem('selectMenuId');
      console.log(  this.tempObj.temporaryPageEnd,'  this.tempObj.temporaryPageEnd')
      this.isRender = true;
    },
    handleOpenLocalPath(data) {
      console.log(data.data.localPath,data.data.openMode)
      if (data.data.openMode == 1) {
        this.$router.push({
          path: data.data.localPath
        })
      } else {
        const { href } = this.$router.resolve({
          path: data.data.localPath
        });
        window.open(href, '_brank');
      }
    }
  }
}

</script>

<style scoped>

</style>
